import { ShieldAlert } from 'lucide-react';
import { PortalDsEmptyState } from 'src/components/portal-design-system';

export function NotAuthorisedState() {
  return (
    <PortalDsEmptyState
      title="Not authorised"
      description="This view is restricted to Invisibly staff. Contact your administrator if you believe you should have access."
      icon={<ShieldAlert className="h-6 w-6" aria-hidden />}
    />
  );
}
